import Vue from 'vue'
import App from './App'
import store from './state'
import router from './router'
import VueShortkey from 'vue-shortkey'
import IdleVue from 'idle-vue'
import VModal from 'vue-js-modal'
import Cp1FormGroup from '@/components/primitives/cp1-form-group/FormGroup'
import Cp1ButtonSubmit from '@/components/primitives/cp1-button-submit/ButtonSubmit'
import vClickOutside from 'v-click-outside'

import '@/communication/FirebaseConfig'
// import VueSocketio from 'vue-socket.io'
// import ConnectionConfig from './communication/ConnectionConfig'

Vue.config.productionTip = false
Vue.use(VueShortkey)
Vue.use(VModal, { dialog: true })
Vue.use(vClickOutside)
// Vue.use(VueSocketio, ConnectionConfig.BASE_URL)

const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 60000 * 30
})

Vue.component('cp1-form-group', Cp1FormGroup)
Vue.component('cp1-button-submit', Cp1ButtonSubmit)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  },
  onIdle () {
    store.dispatch('Login/FORCE_EXPIRE', { expireStatus: 'BYIDLE' })
  }
})

// eslint-disable-next-line no-extend-native
Number.prototype.convertToCurrencyBR = function (decimalPlace = 2) {
  const v = this.valueOf()
  if (!v || v.toString().trim().length < 1) { return '0,'.padEnd(decimalPlace, 0) }
  return v.toFixed(decimalPlace)
    .toString()
    .replace('.', ',')
}



// WEBPACK FOOTER //
// ./src/main.js